import store from '@/store'

export default [
  {
    path: '/admin/company-profiles',
    name: 'company',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/company')
  }
]
